import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import CustomScroll from "react-custom-scroll";

import Notification from "./Notification";
import parseTimeString from "../../../hooks/parseTimeString";
import {formatInterval} from "../../../hooks/formatInterval";
import {getNotifications} from "../../../store/slices/notifications";
import {IDashboardConfig, INotificationsData} from "../../../constants/interfaces";
import {ensureType} from "../../../hooks/ensureType";
import formatPostedOnChannels from "../../../hooks/formatPostedOnChannels";

type Props = {
	cellId: number
}

const NotificationWidget = (props: Props) => {
	const data = useSelector((state: {notifications: {data: INotificationsData[] }}) => state.notifications.data[props.cellId]);
	const isLoading = useSelector((state: {notifications: {isLoading: boolean}}) => state.notifications.isLoading);
	const [notificatioData, setNotificatioData] = useState(data);
	const dispatch = useDispatch();
	const widgetConfig = useSelector(
		(state: {dashboard: {data: IDashboardConfig}}) => ensureType(state.dashboard.data.grid_config.find(cell => cell.cell_id === props.cellId))
	);
	const refreshRate = parseTimeString(widgetConfig.refresh);
	const brands = widgetConfig.brands.join(',');
	const title = widgetConfig.label;
	const timeWindow = widgetConfig.time_window.replace(/360m/,"6h").replace(/720m/,"12h").replace(/1440m/,"24h")
	const extraInfo = (widgetConfig.time_window === "midnight") ? "Today" : "Last " + timeWindow;
	const apiInterval = formatInterval(widgetConfig.time_window);
	const sections = widgetConfig.sections.join('$$');
	const tags = widgetConfig.tags ? widgetConfig.tags.join('$$') : '';
	const isPaid = widgetConfig.paid_type;
	const videoFilter = widgetConfig.video_filter;
	const pageType = widgetConfig.page_type;
	const type = widgetConfig.notification_type;
	const { includeChannels, excludeChannels } = formatPostedOnChannels(widgetConfig.posted_on_channels);

	// initial first load
	useEffect(() => {
		dispatch(getNotifications(brands, apiInterval, sections, tags, type, isPaid, videoFilter, pageType, includeChannels, excludeChannels, props.cellId));
	}, [dispatch, brands, apiInterval, sections, tags, type, isPaid, videoFilter, pageType, includeChannels, excludeChannels, props.cellId]);

	// update data
	useEffect(() => {
		const interval = setInterval(() => {
			dispatch(getNotifications(brands, apiInterval, sections, tags, type, isPaid, videoFilter, pageType, includeChannels, excludeChannels, props.cellId));
		}, refreshRate);
		return () => clearInterval(interval);
	}, [dispatch, refreshRate, brands, apiInterval, sections, tags, type, isPaid, videoFilter, pageType, includeChannels, excludeChannels, props.cellId]);

	// get relevant data from state array
	useEffect(() => {
		setNotificatioData(data);
	}, [data, widgetConfig]);

	const isLoaded = (notificatioData && notificatioData.length)? true : false;
	if (isLoading && !isLoaded) return <div>Loading...</div>;
	if (!notificatioData) return <div>Loading...</div>;

	return (
		<div className="notification-widget">
			<div className="notification-widget__headline">
				<h2>{title}</h2>
				<span>{extraInfo}</span>
			</div>
			<div className="notification-widget__list">
				<CustomScroll heightRelativeToParent="calc(100% - 80px)">
					{
						notificatioData.length > 0 ?
						notificatioData.map((data, index) => (
							<Notification
								key={index}
								data={data}
							/>
						)) : <span>No data</span>
					}
				</CustomScroll>
			</div>
		</div>
	);
}

export default NotificationWidget;
